/** San Diego (Pacific) time helpers — always show coast-local time, whatever the visitor's device zone. */
export const SD_TZ = "America/Los_Angeles";

export const formatSdTime = (d: Date | null | undefined) =>
  d ? d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", timeZone: SD_TZ }) : "—";

export const formatSdDate = (d: Date, opts: Intl.DateTimeFormatOptions = { weekday: "long", month: "long", day: "numeric" }) =>
  d.toLocaleDateString("en-US", { ...opts, timeZone: SD_TZ });

/** Calendar parts of "now" (or a date) in San Diego. */
export function sdParts(d: Date = new Date()) {
  const p = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", {
      timeZone: SD_TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
    }).formatToParts(d).map((x) => [x.type, x.value]),
  );
  return { year: +p.year, month: +p.month, day: +p.day, hour: +p.hour, minute: +p.minute };
}

/** YYYYMMDD for today in San Diego (NOAA begin_date format). */
export function sdTodayNoaa(d: Date = new Date()) {
  const { year, month, day } = sdParts(d);
  return `${year}${String(month).padStart(2, "0")}${String(day).padStart(2, "0")}`;
}

/** Parse a Pacific wall-clock string ("YYYY-MM-DD HH:mm" or ISO without offset) into a real instant. */
export function parseSdWallTime(s: string): Date {
  const [datePart, timePart = "00:00"] = s.replace("T", " ").split(" ");
  const [y, mo, da] = datePart.split("-").map(Number);
  const [h, mi] = timePart.split(":").map(Number);
  const guess = Date.UTC(y, mo - 1, da, h, mi);
  const p = sdParts(new Date(guess));
  const offset = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute) - guess;
  return new Date(guess - offset);
}
